module.exports = __webpack_public_path__ + "../resources/img/ic_cellular_on.a6abf11b.svg";